import { render, staticRenderFns } from "./UpdateThePasswordView.vue?vue&type=template&id=67d03eac&scoped=true"
import script from "./UpdateThePasswordView.vue?vue&type=script&lang=js"
export * from "./UpdateThePasswordView.vue?vue&type=script&lang=js"
import style0 from "./UpdateThePasswordView.vue?vue&type=style&index=0&id=67d03eac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67d03eac",
  null
  
)

export default component.exports